import 'bootstrap/dist/css/bootstrap.min.css';
import { useEffect } from 'react';
import ReactGA from 'react-ga4';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import './App.css';
import Footer from './components/Footer';
import Navi from './components/Navi';
import WhatsAppButton from './components/WhatsAppButton';
import HomeRoutes from './pages/home/HomeRoutes';
import BlogsRoutes from './pages/blog/BlogRoutes';
import TermsAndConditionsPage from './pages/termsAndConditions/TermsAndConditionsPage';
import AsesoresPage from './pages/asesores/AsesoresPage';

function App() {
  useEffect(() => {
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://cdn.bitrix24.com/b2514537/crm/site_button/loader_16_p94bzx.js?' + (Date.now() / 60000 | 0);
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  useEffect(() => {
    ReactGA.initialize('AW-11239929039');
  }, [])

  return (
    <Router>
      <div className="App">
        <Navi />
        <Routes>
          <Route path="/*" element={<HomeRoutes />} />
          <Route path="/blog/*" element={<BlogsRoutes />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditionsPage />} />
          <Route path="/asesores" element={<AsesoresPage />} />
        </Routes>
        <Footer />
        <WhatsAppButton />
      </div>
    </Router>
  );
}

export default App;
